__turbopack_context__.v({
  "active": "headerActions-module-scss-module__VdmLtq__active",
  "cartBtn": "headerActions-module-scss-module__VdmLtq__cartBtn",
  "changed": "headerActions-module-scss-module__VdmLtq__changed",
  "colored": "headerActions-module-scss-module__VdmLtq__colored",
  "counter": "headerActions-module-scss-module__VdmLtq__counter",
  "currentLocale": "headerActions-module-scss-module__VdmLtq__currentLocale",
  "headerActions": "headerActions-module-scss-module__VdmLtq__headerActions",
  "hovered": "headerActions-module-scss-module__VdmLtq__hovered",
  "identityLink": "headerActions-module-scss-module__VdmLtq__identityLink",
  "identityLinks": "headerActions-module-scss-module__VdmLtq__identityLinks",
  "localeLink": "headerActions-module-scss-module__VdmLtq__localeLink",
  "locales": "headerActions-module-scss-module__VdmLtq__locales",
  "localesList": "headerActions-module-scss-module__VdmLtq__localesList",
  "logo": "headerActions-module-scss-module__VdmLtq__logo",
  "opened": "headerActions-module-scss-module__VdmLtq__opened",
  "profileBtn": "headerActions-module-scss-module__VdmLtq__profileBtn",
  "searchBtn": "headerActions-module-scss-module__VdmLtq__searchBtn",
  "toggler": "headerActions-module-scss-module__VdmLtq__toggler",
  "visible": "headerActions-module-scss-module__VdmLtq__visible",
  "wishlistBtn": "headerActions-module-scss-module__VdmLtq__wishlistBtn",
});
